import { message } from 'antd';
import i18next from 'i18next';

export const copyUrlToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(window.location.href);
    message.success({
      content:
        i18next.t('common|Link copied to clipboard') ||
        'Link copied to clipboard',
      duration: 10,
      closable: true,
    });
    return true;
  } catch (error) {
    console.error('Failed to copy URL to clipboard:', error);
    message.error({
      content: i18next.t('common|Failed to copy link') || 'Failed to copy link',
      duration: 10,
    });
    return false;
  }
};
